import Marionette from 'backbone.marionette';

import OfferEditView from '../views/editor';

import Offer from '../models/offer';

module.exports = function (options) {
  const regions = new Marionette.RegionManager({
    regions: {
      view: '#layout-hook'
    }
  });

  const model = new Offer({
    id: options.initialData.id
  });
  model.fetch();

  regions.get('view').show(new OfferEditView({ model }));
};



// WEBPACK FOOTER //
// ./offers/initializers/edit.js